// Russian dictionary — the master key set: en.ts must carry exactly these keys (checked by the compiler).
// `{name}` is a param, `{name|one|few|many}` a plural form picked by that param (see index.ts format()).
// Proper names are listed in docs/glossary-en.md alongside their English twins.

export const RU = {
  /* ---------------- classes, roles ---------------- */
  'class.knight': 'Рыцарь',
  'class.alchemist': 'Алхимик',
  'class.reaper': 'Жнец',
  'class.doctor': 'Доктор',
  'class.outsider': 'Астрал',
  'class.summoner': 'Заклинатели',
  'role.guard': 'Страж',
  'role.shooter': 'Стрелок',
  'role.duelist': 'Дуэлянт',
  'role.support': 'Опора',
  'role.gamechanger': 'Геймченджер',
  'role.summoner': 'Призыватель',

  /* ---------------- heroes ---------------- */
  'hero.rhino': 'Носорог',
  'hero.durer': 'Рыцарь Дюрера',
  'hero.landsknecht': 'Ландскнехт',
  'hero.arquebusier': 'Аркебузир',
  'hero.astrologer': 'Астролог',
  'hero.salamander': 'Саламандра',
  'hero.death': 'Смерть',
  'hero.ferryman': 'Палач-перевозчик',
  'hero.devil': 'Дьявол-дуэлянт',
  'hero.plague': 'Чумной доктор',
  'hero.monk': 'Монах-лекарь',
  'hero.grotesque': 'Гротеск',
  'hero.shadow': 'Тень',
  'hero.sin': 'Грех',
  'hero.nightmare': 'Кошмар',
  'hero.birdcatcher': 'Птицелов',
  'hero.puppeteer': 'Кукольник',
  'hero.shewolf': 'Волчица',

  /* ---------------- skills: names ---------------- */
  'skill.rhino.Q': 'Таран',
  'skill.rhino.W': 'Стойка',
  'skill.durer.Q': 'Вызов',
  'skill.durer.W': 'Павеза',
  'skill.landsknecht.Q': 'Размах',
  'skill.landsknecht.W': 'Боевой клич',
  'skill.arquebusier.Q': 'Прицельный выстрел',
  'skill.arquebusier.W': 'Отход',
  'skill.astrologer.Q': 'Звёздный залп',
  'skill.astrologer.W': 'Прорицание',
  'skill.salamander.Q': 'Огненная струя',
  'skill.salamander.W': 'Горючий след',
  'skill.death.Q': 'Выпад',
  'skill.death.W': 'Финт',
  'skill.ferryman.Q': 'Крюк',
  'skill.ferryman.W': 'Фонарь душ',
  'skill.devil.Q': 'Прыжок',
  'skill.devil.W': 'Сделка',
  'skill.plague.Q': 'Склянка',
  'skill.plague.W': 'Оберег',
  'skill.monk.Q': 'Молитва',
  'skill.monk.W': 'Святой круг',
  'skill.grotesque.Q': 'Чумное облако',
  'skill.grotesque.W': 'Взмах перьев',
  'skill.shadow.Q': 'Слиться',
  'skill.shadow.W': 'Тень на стене',
  'skill.sin.Q': 'Соблазн',
  'skill.sin.W': 'Расплата',
  'skill.nightmare.Q': 'Стая',
  'skill.nightmare.W': 'Наваждение',
  'skill.birdcatcher.Q': 'Стая сорок',
  'skill.birdcatcher.W': 'Сокол на перчатке',
  'skill.puppeteer.Q': 'Голем из глины',
  'skill.puppeteer.W': 'Связка',
  'skill.shewolf.Q': 'Стая',
  'skill.shewolf.W': 'Обернуться',

  /* ---------------- skills: descriptions (numbers come from core's SKILLS, see heroInfo.ts) ---------------- */
  'skill.rhino.Q.desc': 'Рывок до {range} м: первый встреченный враг получает {dmg} урона, отлетает и оглушён на {stun} с; если позади него стена — оглушение ещё +{wallStun} с.',
  'skill.rhino.W.desc': 'Стойка на {dur} с: удары спереди (сектор {arc}) полностью блокируются, скорость −{slow}, лечит {heal} макс. здоровья в секунду. Если стойка что-то заблокировала, следующая атака оглушает на {stun} с.',
  'skill.durer.Q.desc': 'Враги в радиусе {r} м на {taunt} с вынуждены атаковать только его; каст и зарядка у них сбиваются.',
  'skill.durer.W.desc': 'Ставит перед собой щит-стену шириной {width} м на {life} с — она останавливает вражеские снаряды.',
  'skill.landsknecht.Q.desc': 'Удар полукругом ({arc}) на {range} м: {dmg} урона каждому и отбрасывание.',
  'skill.landsknecht.W.desc': 'Он и союзники в радиусе {r} м получают +{haste} к скорости на {life} с.',
  'skill.arquebusier.Q.desc': 'Зажмите, чтобы зарядить (до {charge} с; при зарядке скорость −{slow}). Урон {dmgMin}–{dmgMax} и дальность {rangeMin}–{rangeMax} м растут с зарядом.',
  'skill.arquebusier.W.desc': 'Прыжок на {range} м назад; на старом месте остаётся ловушка (взводится за {arm} с, живёт {life} с). Наступивший враг получает {dmg} урона, замедление {slow} на {slowFor} с и виден 2 с.',
  'skill.astrologer.Q.desc': 'Веер из трёх звёзд на {range} м, каждая — {dmg} урона.',
  'skill.astrologer.W.desc': 'Точка до {range} м: круг радиусом {r} м на {life} с открывает туман и траву, враги внутри теряют {drain} макс. здоровья в секунду.',
  'skill.salamander.Q.desc': 'Струя пламени на {range} м конусом {arc} в течение {life} с, {dps} урона в секунду; струю можно вести за целью, сама Саламандра при этом идёт на {slow} медленнее.',
  'skill.salamander.W.desc': 'Прыжок на {range} м назад; на старом месте горит лужа радиусом {r} м — {dps} урона в секунду врагам, {life} с.',
  'skill.death.Q.desc': 'Рывок на {range} м сквозь врагов: каждый на пути получает {dmg} урона. Попадание сразу сбрасывает перезарядку (не чаще раза в {window} с).',
  'skill.death.W.desc': 'Шаг на {range} м и {invuln} с неуязвимости. Если в это время по нему ударили, следующий Выпад наносит ×{mult} урона и не уходит на перезарядку.',
  'skill.ferryman.Q.desc': 'Крюк на {range} м: первый враг получает {dmg} урона, оглушён на {stun} с и притянут вплотную.',
  'skill.ferryman.W.desc': 'Фонарь вокруг него радиусом {r} м на {life} с: враги внутри замедлены на {slow} и видны.',
  'skill.devil.Q.desc': 'Прыжок в точку до {range} м: враги в радиусе {r} м при приземлении получают {dmg} урона и замедление {slow} на {slowFor} с.',
  'skill.devil.W.desc': 'Отдаёт {cost} базового здоровья (не убивает — остаётся минимум 1) и на {life} с наносит +{bonus} урона.',
  'skill.plague.Q.desc': 'Склянка в точку до {range} м: лужа радиусом {r} м на {life} с лечит союзников на {heal} в секунду, а врагам наносит {dmg} урона в секунду и замедляет на {slow}.',
  'skill.plague.W.desc': 'Щит на {shield} урона союзнику (до {range} м) или себе на {life} с, снимает замедления. Если щит не пробили, перезарядка короче на {refund}.',
  'skill.monk.Q.desc': 'Союзник (до {range} м) или он сам восстанавливает {total} здоровья за {life} с.',
  'skill.monk.W.desc': 'Круг радиусом {r} м на {life} с: союзников внутри нельзя оглушить, замедлить, отбросить, соблазнить или напугать.',
  'skill.grotesque.Q.desc': 'Ядовитое облако радиусом {r} м ползёт вперёд ({speed} м/с) {life} с, {dps} урона в секунду врагам внутри.',
  'skill.grotesque.W.desc': 'Взмах: враги в радиусе {r} м получают {dmg} урона и отлетают.',
  'skill.shadow.Q.desc': 'Только в траве или вне обзора врагов: до {life} с она невидима для противника — даже вплотную и под раскрытием. Покинет укрытие — невидимость спадёт. Атака из невидимости снимает её, и {hits} {hits|удар|удара|ударов} подряд (в течение {window} с) наносят ×{mult} урона. Пока невидима, восстанавливает ещё +{regen}% макс. здоровья в секунду.',
  'skill.shadow.W.desc': 'Бросает тень в точку до {range} м; через {delay} с меняется с ней местами. Там, откуда она исчезла, и там, где появилась, все враги в радиусе {r} м получают {dmg} урона (оказавшийся в обоих кругах — один раз).',
  'skill.sin.Q.desc': 'Враг в пределах {range} м на {life} с сам идёт к Греху: не слушается приказов, не атакует, не применяет навыки и артефакты. Всё это время Грех вытягивает из него {drain} макс. здоровья в секунду и лечит себя на столько же.',
  'skill.sin.W.desc': 'На {life} с союзники в радиусе {r} м от Греха получают лишь {taken} урона, а сам Грех принимает только {self} от удара — остальное сгорает (его щит и защита действуют как обычно).',
  'skill.nightmare.Q.desc': 'Стаей птиц перелетает в точку до {range} м, неуязвим в полёте. Враги в {r} м от места посадки на {fear} с в страхе бегут к своей базе, не слушаясь приказов.',
  'skill.nightmare.W.desc': 'На {life} с враги в радиусе {r} м от него путают своих и чужих: обычная атака с шансом {chance} уходит в ближайшего их союзника в радиусе атаки и наносит {mult} урона.',
  'skill.birdcatcher.Q.desc': 'Выпускает {count} {count|сороку|сороки|сорок} на {life} с (по {hp} здоровья): летят над стенами, клюют по {dmg} урона его цель или ближайшего врага. Каждый клевок откладывает начатое врагом применение навыка на {delay} с.',
  'skill.birdcatcher.W.desc': 'Сокол летит к врагу в пределах {range} м ({speed} м/с) и бьёт: {dmg} урона и замедление на {slow} на {slowFor} с.',
  'skill.puppeteer.Q.desc': 'Лепит голема в точке до {range} м на {life} с: {hp} здоровья, сам бьёт ближайшего врага, существо или монстра в {aggro} м на {dmg} урона, а без них идёт на ближайшую не нашу точку и удерживает её: мешает врагу захватывать, но сам точку не берёт. Голем один: новый заменяет старого.',
  'skill.puppeteer.W.desc': 'Бросок в точку до {range} м: каждого врага в круге {r} м связывает на {life} с с ближайшим в этом круге — другим врагом (друг с другом), существом, монстром, деревом или стеной. Связанные могут сближаться, но не расходиться дальше, чем уже сошлись. Прерывает каст и рывок. Некого связать — промах, перезарядка всё равно идёт.',
  'skill.shewolf.Q.desc': 'Зовёт {count} {count|волка|волков|волков} на {life} с (по {hp} здоровья): кусают её цель по {dmg} урона, обходя её с боков.',
  'skill.shewolf.W.desc': 'На {life} с оборачивается волчицей: +{haste} к скорости, атакует вблизи ({range} м) и наносит +{bonus} урона.',

  /* ---------------- passives ---------------- */
  'passive.rhino': 'Толстая шкура',
  'passive.durer': 'Покровитель',
  'passive.landsknecht': 'Двуручник',
  'passive.arquebusier': 'Сошка',
  'passive.astrologer': 'Звездочёт',
  'passive.salamander': 'Липкое пламя',
  'passive.death': 'Memento mori',
  'passive.ferryman': 'Тяжёлая рука',
  'passive.devil': 'Кровавый долг',
  'passive.plague': 'Сортировка',
  'passive.monk': 'Смирение',
  'passive.grotesque': 'Мерзость',
  'passive.shadow': 'Без отражения',
  'passive.sin': 'Первородный',
  'passive.nightmare': 'Бессонница',
  'passive.birdcatcher': 'Зоркий глаз',
  'passive.puppeteer': 'Мастер',
  'passive.shewolf': 'Вожак',
  'passive.rhino.desc': 'Отбрасывание и притягивание сдвигают его только на {mult} расстояния.',
  'passive.durer.desc': 'Союзники в {r} м от него получают на {reduce} меньше урона (до щитов). На него самого не действует.',
  'passive.landsknecht.desc': 'Обычная атака задевает ещё одного ближайшего врага в секторе {arc} перед ним — {share} урона атаки.',
  'passive.arquebusier.desc': 'Простояв на месте {still} с, стреляет обычной атакой на {bonus} м дальше; бонус пропадает, как только он сдвинется.',
  'passive.astrologer.desc': 'Любой вражеский герой, задетый его уроном, виден всей его команде {reveal} с — даже в траве и тумане.',
  'passive.salamander.desc': 'Враг, задетый её огнём (струя или лужа), горит ещё {burn} с — {dps} урона в секунду.',
  'passive.death.desc': '+{bonus} урона по вражеским героям, у которых меньше {below} здоровья.',
  'passive.ferryman.desc': 'Обычные атаки замедляют цель на {slow} на {slowFor} с.',
  'passive.devil.desc': 'Лечится на {leech} урона, нанесённого вражеским героям (урон по монстрам не лечит).',
  'passive.plague.desc': 'Лечение Склянки и щит Оберега на {bonus} сильнее на союзнике, у которого меньше {below} здоровья.',
  'passive.monk.desc': 'Оглушения, замедления, соблазн и страх на нём длятся на {cut} короче; сам восстанавливает ещё +{regen}% макс. здоровья в секунду сверх обычных {base}%.',
  'passive.grotesque.desc': 'Герой ближнего боя, ударивший его обычной атакой, сам получает {dmg} урона.',
  'passive.shadow.desc': 'Ловушки её не выдают, а Прорицание показывает её лишь первые {revealFor} с. Простояв на месте {stillFor} с, она становится силуэтом: её видно, но ни атака, ни навык, ни зона, ни контроль её не задевают, а вражеские приказы атаковать её сбрасываются; на точке силуэт удерживает, но не захватывает: оспаривает точку и не даёт врагу её отбить, но сам прогресс не двигает и захват напарника не ускоряет. Силуэт спадает, как только она сдвинется, начнёт атаку или применит навык, артефакт или реликвию; пока стоит её Тотем Гнева, силуэтом она не станет.',
  'passive.sin.desc': 'Если он ранил врага за последние {window} с, убийство этого врага его командой приносит ещё +{bonus} очков.',
  'passive.nightmare.desc': 'Враги в {r} м от него не восстанавливают здоровье — ни регенерацией, ни лечением; фонтан лечит их вдвое слабее.',
  'passive.birdcatcher.desc': 'Его сороки видят на {sight} м вокруг себя, поверх деревьев.',
  'passive.puppeteer.desc': 'Когда его голема разбивают (не когда тот рассыпается сам), Кукольник получает щит в {shield} макс. здоровья на {life} с.',
  'passive.shewolf.desc': 'Пока хоть один её волк в {r} м от неё, она получает на {reduce} меньше урона.',

  /* ---------------- artifacts ---------------- */
  'art.shoulder': 'Наплечник',
  'art.whetstone': 'Точильный камень',
  'art.boots': 'Сапоги гонца',
  'art.salve': 'Целебная мазь',
  'art.hourglass': 'Песочные часы',
  'art.mistAmulet': 'Туманный амулет',
  'art.graveCandle': 'Могильная свеча',
  'art.dragonTooth': 'Зуб дракона',
  'art.banner': 'Знамя',
  'art.bloodvial': 'Склянка крови',
  'art.windoil': 'Ветряное масло',
  'art.cloak': 'Пергаментный плащ',
  'art.totemWard': 'Тотем Стойкости',
  'art.totemWrath': 'Тотем Гнева',
  'art.brand': 'Клеймо',
  'art.tar': 'Смоляная бутыль',
  'art.shoulder.desc': '+{hp} максимального здоровья',
  'art.whetstone.desc': '+{atk}% скорость атаки',
  'art.boots.desc': '+{move}% скорости передвижения вне боя ({quiet} с без урона)',
  'art.salve.desc': '+{regen}% здоровья в секунду вне боя ({quiet} с без урона)',
  'art.hourglass.desc': 'Перезарядка умений и активных артефактов идёт на {rate}% быстрее',
  'art.mistAmulet.desc': 'Обычная атака врага по вам промахивается с шансом {chance}%',
  'art.graveCandle.desc': 'Возрождение на {cut}% быстрее',
  'art.dragonTooth.desc': '+{dmg}% урона по вражеским героям, у которых больше {above}% здоровья',
  'art.banner.desc': 'Точка под вами захватывается на {cap}% быстрее (два знамени не складываются)',
  'art.bloodvial.desc': 'Копит {rate}% здоровья в секунду, до {max}%; выпить можно в любой момент — лечит накопленное',
  'art.windoil.desc': '+{haste}% скорости передвижения на {dur} с',
  'art.cloak.desc': '{dur} с чистый контур: нельзя прицелиться, не бьёт и не колдует',
  'art.totemWard.desc': 'Ставится под ноги: {life} с лечит союзников в {r} м по {pct}% здоровья в секунду, ломается с {hp} ударов',
  'art.totemWrath.desc': 'Ставится под ноги: {life} с отнимает у врагов в {r} м по {pct}% здоровья в секунду, ломается с {hp} ударов',
  'art.brand.desc': 'Враг или монстр в {range} м получает +{pct}% урона на {dur} с',
  'art.tar.desc': 'Бросок на {range} м: лужа {r} м/{life} с, замедление {slow}%',

  /* ---------------- relics ---------------- */
  'relic.martyrShield': 'Щит Мученика',
  'relic.wildHorn': 'Рог Дикой Охоты',
  'relic.bestiaryEye': 'Око Бестиария',
  'relic.hydraHeart': 'Сердце Гидры',
  'relic.martyrShield.desc': 'Нажать (T): {dur} с неуязвимости вам и союзнику в {r} м — бить и колдовать можно; перезарядка {cd} с',
  'relic.wildHorn.desc': 'Всегда: +{move}% скорости бега и +{atk}% скорости атаки обоим',
  'relic.bestiaryEye.desc': 'Нажать (T): {dur} с команда видит всю карту и наносит +{dmg}% урона героям, перезарядка её навыков и артефактов идёт на {rate}% быстрее — ни тумана, ни травы, видны даже невидимые; перезарядка {cd} с',
  'relic.hydraHeart.desc': 'Всегда: +{regen}% здоровья в секунду обоим, и в бою тоже',

  /* ---------------- monsters, summoned creatures ---------------- */
  'monster.behemoth': 'Бегемот',
  'monster.griffin': 'Грифон',
  'summon.magpie': 'Сорока',
  'summon.golem': 'Голем',
  'summon.wolf': 'Волк',

  /* ---------------- teams ---------------- */
  'team.a': 'Кровавые',
  'team.b': 'Чернильные',
  'team.a.full': 'Кровавый оттиск',
  'team.b.full': 'Чернильный оттиск',

  /* ---------------- built-in maps (by their stored name; user maps show their own name) ---------------- */
  'map.Погорелый посад': 'Погорелый посад',
  'map.Сенокос': 'Сенокос',
  'map.Мельничный брод': 'Мельничный брод',
  'map.Волчья чаща': 'Волчья чаща',
  'map.Каменный перевал': 'Каменный перевал',

  /* ---------------- map validation issues (core codes, see core/map/schema.ts MapIssueCode) ---------------- */
  'mapIssue.expectedObject': 'ожидался объект',
  'mapIssue.requiredField': 'обязательное поле',
  'mapIssue.unknownField': 'неизвестное поле',
  'mapIssue.expectedArray': 'ожидался массив',
  'mapIssue.expectedNumber': 'ожидалось конечное число, получено {got}',
  'mapIssue.mustBePositive': 'должно быть > 0, получено {got}',
  'mapIssue.expectedPoint': 'ожидалась точка [x, z]',
  'mapIssue.expectedOneOf': 'ожидалось одно из {options}, получено {got}',
  'mapIssue.expectedBool': 'ожидалось true или false',
  'mapIssue.pointsCoincide': 'точки {i} и {j} совпадают',
  'mapIssue.lineTooShort': 'линии нужно минимум 2 точки, получено {n}',
  'mapIssue.polygonTooShort': 'полигону нужно минимум 3 точки, получено {n}',
  'mapIssue.polygonZeroArea': 'у полигона нулевая площадь',
  'mapIssue.polygonEdgesCross': 'рёбра полигона {i} и {j} пересекаются',
  'mapIssue.centerNotSymmetric': 'его отражение (-x, -z) отсутствует в center: центральные объекты должны быть симметричны как набор',
  'mapIssue.outsideMap': 'вне карты (|x| <= {hw}, |z| <= {hh})',
  'mapIssue.baseNearEdge': 'слишком близко к краю: держите в пределах |x| <= {hw}, |z| <= {hh}, чтобы лавка и флаг оставались на карте',
  'mapIssue.mirroredHalfPoint': 'на отражённой половине: разместите на стороне команды A от диагонали база-база',
  'mapIssue.noVertexInside': 'ни одна точка не внутри карты',
  'mapIssue.mirroredHalf': 'на отражённой половине: создайте на стороне команды A от диагонали база-база, отражение добавляется при загрузке',
  'mapIssue.mirroredHalfCentroid': 'на отражённой половине (по центроиду точек): создайте на стороне команды A от диагонали база-база, отражение добавляется при загрузке',
  'mapIssue.duplicates': 'дублирует {first}',
  'mapIssue.mirrorDuplicates': 'его отражение дублирует {first}',
  'mapIssue.duplicatesMirrorOf': 'дублирует отражение {first}',
  'mapIssue.bridgeNotOnStream': 'не на ручье (должен быть в пределах {reach} м от него)',
  'mapIssue.bridgeStreamTooWide': 'ручей под ним шире {span} м: мост столько не перекрывает',
  'mapIssue.fordMissesStream': 'не пересекает ручей: центральная линия ручья должна проходить через прямоугольник брода',
  'mapIssue.fordTooShort': 'не перекрывает ручей от берега до берега: нужно не меньше {need} м поперёк ручья',
  'mapIssue.fordTooNarrow': 'слишком узкий: нужно не меньше {need} м вдоль ручья на всём переходе',
  'mapIssue.tooClose': 'слишком близко к {place} ({d} м, нужно не менее {gap} м)',
  'mapIssue.unsupportedFormat': 'неподдерживаемый формат {got}, ожидался 1',
  'mapIssue.expectedName': 'ожидалась непустая строка',
  'mapIssue.sizeOutOfRange': 'должно быть в пределах {min}..{max} м, получено {got}',
  'mapIssue.centerPointNotOrigin': 'центральная точка должна быть в [0, 0]',
  'mapIssue.error': '{text}',
  'mapIssue.mapUnreadable': 'карту не удалось прочитать: данные повреждены',
  'mapIssue.notJson': 'файл не является JSON',
  'mapIssue.fileNotJson': '{file} — не JSON',
  'mapIssue.fileTooLarge': 'файл больше {kb} КБ — это не карта',
  'mapIssue.storageUnavailable': 'хранилище браузера недоступно (приватный режим или запрет сайта): карты не сохраняются',
  'mapIssue.storageFull': 'в хранилище браузера не хватает места: удалите ненужные карты или экспортируйте их в файлы',
  'mapIssue.storageWriteFailed': 'не удалось записать в хранилище браузера: {error}',
  'mapIssue.nameEmpty': 'введите название карты',
  'mapIssue.nameSpaces': 'название не должно начинаться или заканчиваться пробелом',
  'mapIssue.nameTooLong': 'название длиннее {max} символов',
  'mapIssue.fileNameInvalid': 'имя файла: строчные латинские буквы, цифры и дефисы (до 40)',
  'mapIssue.nameTaken': 'карта «{name}» уже есть',
  'mapIssue.notFound': 'карты «{name}» нет',
  'mapIssue.devServerDown': 'dev-сервер недоступен: {error}',
  'mapIssue.serverError': 'ошибка сервера, HTTP {status}',
  'mapIssue.noTemplate': 'нет шаблона {name}',
  'mapPlace.base': 'base',
  'mapPlace.baseMirror': 'отражённая база',
  'mapPlace.pointsSide': 'points.side',
  'mapPlace.pointsCenter': 'points.center',
  'mapPlace.pointsSideMirror': 'отражённая боковая точка',
  'mapPlace.denPos': 'den.pos',
  'mapPlace.denMirror': 'отражённое логово',

  /* ---------------- common, front screens, settings ---------------- */
  'common.back': 'Назад',
  'common.next': 'Далее',
  'common.loading': 'Загрузка…',
  'player.nameless': 'Игрок',
  'front.tagline': '2×2 · бой за три точки · {n} {n|герой|героя|героев}',
  'front.pressAnyKey': 'Нажмите любую клавишу',
  'menu.aria': 'Главное меню',
  'menu.online': 'Играть онлайн',
  'menu.bots': 'Играть против ботов',
  'menu.editor': 'Редактор карт',
  'menu.replays': 'Мои повторы',
  'menu.heroes': 'Герои / Артефакты',
  'menu.settings': 'Настройки',
  'menu.you': 'Вы — {name}',
  'menu.noName': 'Имя не задано — спросим перед онлайном',
  'settings.title': 'Настройки',
  'settings.name': 'Имя игрока',
  'settings.lang': 'Язык',
  'settings.sound': 'Звук',
  'settings.on': 'Вкл',
  'settings.off': 'Выкл',
  'settings.volume': 'Громкость',
  'settings.quality': 'Качество графики',
  'settings.quality.auto': 'Авто',
  'settings.quality.high': 'Высокое',
  'settings.quality.medium': 'Среднее',
  'settings.quality.low': 'Низкое',
  'settings.style': 'Графика',
  'settings.style.engrave': 'Оригинал',
  'settings.style.toon': 'Мультяшная',
  'settings.fog': 'Туман войны',
  'settings.fog.color': 'Цветной',
  'settings.fog.mono': 'Двухцветный',
  'settings.hints': 'Подсказки управления',
  'settings.hints.show': 'Показывать',
  'settings.hints.hide': 'Скрыть',
  'settings.lockCursor': 'Удерживать курсор в окне',
  'nameEntry.title': 'Как вас зовут?',
  'nameEntry.note': 'Имя увидят другие игроки в комнате.',
  'nameEntry.empty': 'Введите имя',

  /* ---------------- static page (index.html), plate and slot words drawn by CSS ---------------- */
  'stage.aria': 'Матч 2×2',
  'legend.move': '<kbd>ЛКМ</kbd>/<kbd>ПКМ</kbd> <b>по земле</b> — идти, <b>по врагу</b> — бить, <b>по союзнику</b> — держаться рядом',
  'legend.skills': '<kbd>Q</kbd> <kbd>W</kbd> навыки: прицельные — <kbd>ЛКМ</kbd> по цели (выстрел Алхимика — держать <kbd>ЛКМ</kbd>), <kbd>ПКМ</kbd>/<kbd>Esc</kbd> отмена',
  'legend.shop': 'артефакты — в лавке на базе: клик по прилавку или <kbd>B</kbd> открывает её, продажа возвращает половину',
  'legend.zoom': 'колесо — масштаб',
  'legend.minimap': '<kbd>ПКМ</kbd> по мини-карте — идти туда',
  'legend.mute': '<kbd>M</kbd> звук вкл/выкл',
  'plate.charm': ' · соблазн',
  'plate.fear': ' · страх',
  'plate.stun': ' · оглушён',
  'plate.brace': ' · стойка',
  'slot.passive': 'пассивный',

  /* ---------------- main wiring, replay errors ---------------- */
  'main.webglTitle': 'Не удалось запустить графику',
  'main.webglText': 'Браузер не смог запустить WebGL. Включите аппаратное ускорение и перезагрузите страницу.',
  'main.rematch': 'Ещё матч',
  'main.fromEditorMap': '{name} (из редактора)',
  'main.fromEditorGroup': 'Из редактора',
  'main.mapBroken': 'Эта карта не открывается',
  'main.editorFailTitle': 'Не удалось запустить редактор',
  'main.editorFailText': 'Редактору нужна графика WebGL. Включите аппаратное ускорение и перезагрузите страницу.',
  'main.replayTitle': 'Повтор матча',
  'main.replayFailed': 'Повтор не открылся',
  'replayError.notFound': 'Повтор не найден или удалён — записи хранятся 7 дней.',
  'replayError.unavailable': 'Повтор этого матча недоступен — запись не удалось сохранить.',
  'replayError.network': 'Не удалось связаться с сервером. Проверьте соединение и попробуйте ещё раз.',
  'replayError.busy': 'Сервер сейчас занят. Попробуйте через минуту.',
  'replayError.corrupt': 'Файл повтора повреждён — его не получается прочитать.',
  'replayError.list': 'Не удалось загрузить список повторов. Попробуйте ещё раз.',
  'replayError.outdated': 'Запись сделана в старой версии игры и больше не воспроизводится',

  /* ---------------- hero select, hero marks ---------------- */
  'common.cooldown': 'перезарядка {cd} с',
  'common.passiveLine': 'Пассивка: {name} — {desc}',
  'hs.title': 'Выбор героя',
  'hs.confirm': 'В бой',
  'hs.map': 'Карта:',
  'hs.hp': 'Здоровье',
  'hs.speed': 'Скорость',
  'hs.range': 'Дальность атаки',
  'hs.dmg': 'Урон',
  'icon.melee': 'Ближний бой',
  'icon.ranged': 'Дальний бой',
  'icon.summon': 'Существа',
  'icon.dash': 'Рывок',
  'icon.stun': 'Оглушение',
  'icon.aoe': 'Урон по площади',
  'icon.zone': 'Зона на земле',
  'icon.heal': 'Лечение',
  'icon.shield': 'Щит',
  'icon.reveal': 'Зрение',
  'icon.control': 'Контроль',
  'icon.empower': 'Усиление',

  /* ---------------- shop ---------------- */
  'shop.notInBase': 'нужно быть на базе',
  'shop.noSlot': 'оба слота заняты — продайте что-то',
  'shop.locked': 'заблокировано ещё {s} с',
  'shop.noInk': 'не хватает чернил (нужно {cost})',
  'shop.sell': 'Продать · +{n}',
  'shop.buy': 'Купить · {cost}',
  'shop.lockedShort': 'занято {s} с',
  'shop.needInk': 'нужно {cost}',
  'shop.noSlotShort': 'нет слота',
  'shop.relic.ours': 'эта реликвия у вашей команды',
  'shop.relic.theirs': 'у врага — выбейте её, и она вернётся в лавку',
  'shop.relic.teamHasOne': 'у команды уже есть реликвия',
  'shop.relic.oursShort': 'У нас',
  'shop.relic.theirsShort': 'У врага',
  'shop.relic.teamHasOneShort': 'уже есть',
  'shop.relic.auto': 'сама',
  'shop.relicsLabel': 'Реликвии — одна на команду, {cost} чернил, у обоих сразу; смерть любого из вас — и она потеряна',
  'shop.passiveLabel': 'Пассивные — работают сами',
  'shop.activeLabel': 'Активные — в E или R',

  /* ---------------- skill and slot tooltips ---------------- */
  'target.instant': 'мгновенно',
  'target.direction': 'по направлению',
  'target.point': 'в точку',
  'target.charge': 'зарядка — зажать и отпустить',
  'target.ally': 'на союзника',
  'target.enemy': 'на врага',
  'tip.emptySlot': 'Пусто — купите артефакт в лавке на базе',
  'tip.empty': 'Пусто',
  'tip.vialCharge': 'Заряд: {pct}% (макс. {max}%, +{rate}% в секунду)',
  'tip.worksItself': 'действует сам',
  'tip.noRelic': 'Реликвии нет — купите в лавке на базе за {cost}',
  'tip.teamRelic': 'реликвия команды',
  'tip.relicWorksItself': 'действует сама',
  'tip.sharedCooldown': 'перезарядка {cd} с, общая на двоих',
  'tip.relicLost': 'Умрёт любой из вас — реликвия потеряна и вернётся в лавку',
  'tip.cdLeft': 'ещё {s} с',

  /* ---------------- codex: heroes / artifacts guide ---------------- */
  'codex.heroes': 'Герои',
  'codex.artifacts': 'Артефакты',
  'guide.passive': 'Пассивные',
  'guide.active': 'Активные',
  'guide.relics': 'Реликвии',
  'guide.fullCharge': 'полный заряд за {cd} с',
  'guide.typeActive': 'активный (кнопка E/R)',
  'guide.typePassive': 'пассивный',
  'guide.noteBuy': 'Покупается на базе за {cost} чернил из общего запаса команды',
  'guide.noteActive': 'Занимает слот E или R — нажмите эту клавишу, чтобы применить',
  'guide.notePassive': 'Занимает слот E или R и работает сам — нажимать нечего',
  'guide.noteSell': 'Продажа на базе возвращает {n}',
  'guide.typeRelic': 'реликвия ({key}, одна на матч)',
  'guide.relicNote1': 'Одна на матч: пока она у одной команды, другой её не купить',
  'guide.relicNote2': 'Покупается на базе за {cost} чернил и достаётся обоим сразу; у команды — только одна реликвия',
  'guide.relicNote3': 'Смерть любого из носителей выбивает её — она вернётся в лавку',
  'guide.relicNote4': 'Продать нельзя',
  'guide.price': '{n} чернил',
  'guide.cost': 'Цена',
  'guide.sale': 'Продажа',

  /* ---------------- own-hero stats block, status chips ---------------- */
  'stats.base': 'база {n}',
  'stats.dmg': 'Урон',
  'stats.aps': 'Атак/с',
  'stats.range': 'Дальность, м',
  'stats.speed': 'Скорость бега, м/с',
  'stats.haste': 'ускорение',
  'stats.slow': 'замедление',
  'stats.charging': 'зарядка',
  'stats.ford': 'брод',
  'status.stun': 'оглушение',
  'status.charm': 'соблазн',
  'status.fear': 'страх',
  'status.delusion': 'наваждение',
  'status.sleepless': 'бессонница',
  'status.stealth': 'невидимость',
  'status.silhouette': 'силуэт',
  'status.shield': 'щит',

  /* ---------------- in-match HUD ---------------- */
  'common.toMenu': 'В меню',
  'buff.hp': '{pct} к базовому здоровью',
  'buff.moveAndAttack': '{pct} к скорости бега и атаки',
  'buff.move': '{pct} к скорости бега',
  'buff.attack': '{pct} к скорости атаки',
  'buff.ours': 'Наши',
  'buff.theirs': 'Враги',
  'silence.left': ' ещё {s} с',
  'silence.charm': 'Соблазн: вы идёте к Греху — навыки и артефакты недоступны{left}',
  'silence.fear': 'Страх: вы бежите к своей базе — навыки и артефакты недоступны{left}',
  'relicFeed.bought': '{team} купили «{relic}»',
  'relicFeed.lost': '{team} лишились реликвии «{relic}»',
  'relic.martyrShield.short': 'Щит',
  'relic.wildHorn.short': 'Рог',
  'relic.bestiaryEye.short': 'Око',
  'relic.hydraHeart.short': 'Сердце',
  'slot.noRelic': 'нет реликвии',
  'slot.empty': 'пусто',
  'slot.inShop': 'в лавке',
  'tag.unseen': 'невидима',
  'toast.allySold': 'Союзник продал: {name} (+{n})',
  'toast.allyBought': 'Союзник купил: {name} (−{n})',
  'banner.tallying': ' · подводим итоги…',
  'banner.won': 'Победил {team}',
  'hud.inkTitle': 'Общий запас команды: любой из вас тратит его в лавке',
  'hud.ink': 'Чернила команды',
  'hud.stallHint': 'Лавка открыта — <b>B</b> или клик по прилавку',
  'hud.shopCloseAria': 'Закрыть лавку',
  'hud.shopCloseTitle': 'Закрыть (Esc)',
  'hud.healBlocked': '{name}: лечение заблокировано',
  'hud.minimapTitle': 'ПКМ — идти сюда',
  'hud.miss': 'промах',
  'hud.overtime': 'овертайм',
  'status.respawn': 'Возрождение через {s} с',
  'status.line.charm': 'Соблазн: вы идёте к Греху, приказы не действуют',
  'status.line.fear': 'Страх: вы бежите к своей базе, приказы не действуют',
  'status.line.delusion': 'Наваждение: свои и чужие перепутаны, атака может уйти в союзника',
  'status.line.meld': 'Слиться: враги вас не видят, пока вы в укрытии',
  'status.line.silhouette': 'Силуэт: вас видно, но не задеть, пока вы стоите',
  'status.line.grass': 'В траве: враги вас не видят, пока не подойдут',

  /* ---------------- match results ---------------- */
  'medal.damage': 'Больше всего урона',
  'medal.damageValue': '{n} урона',
  'medal.capture': 'Главный захватчик',
  'medal.captureValue': '{n} захв. · {time}',
  'medal.undying': 'Неубиваемый',
  'medal.undyingValue': '{n} смерт. · {taken} получено',
  'medal.hunter': 'Охотник на чудищ',
  'medal.hunterValue': '{n} чудищ',
  'medal.healer': 'Лекарь',
  'medal.healerValue': '{n} лечения',
  'res.passiveTip': 'Пассивка «{name}»: {stat}',
  'res.passiveStat.rhino': '{v} м продавливания снято',
  'res.passiveStat.durer': '{v} урона поглощено союзниками',
  'res.passiveStat.landsknecht': '{v} урона вторым ударом',
  'res.passiveStat.arquebusier': '{v} атак с доп. дальностью',
  'res.passiveStat.astrologer': '{v} с обзора врагов открыто',
  'res.passiveStat.salamander': '{v} урона от дожига',
  'res.passiveStat.death': '{v} доп. урона от бонуса',
  'res.passiveStat.ferryman': '{v} с замедления наложено',
  'res.passiveStat.devil': '{v} hp вылечено долгом',
  'res.passiveStat.plague': '{v} доп. лечения и щита',
  'res.passiveStat.monk': '{v} с оглушений/замедлений/чар/страха предотвращено',
  'res.passiveStat.grotesque': '{v} урона шипами',
  'res.passiveStat.shadow': '{v} с раскрытия избежано',
  'res.passiveStat.sin': '{v} доп. очков за убийства',
  'res.passiveStat.nightmare': '{v} hp лечения врагов отнято',
  'res.passiveStat.birdcatcher': '{v} с враги на виду у сорок',
  'res.passiveStat.puppeteer': '{v} щита от разбитых големов',
  'res.passiveStat.shewolf': '{v} урона снято стаей',
  'res.bot': 'Бот',
  'res.supportTitle': 'лечение {heal} · щиты {shield}',
  'res.relics': 'Реликвии:',
  'res.relicLost': ' (выбита)',
  'res.teamWon': 'победа',
  'res.col.hero': 'Герой',
  'res.col.kdaTitle': 'Убийства / смерти / помощь',
  'res.col.kda': 'У / С / П',
  'res.col.dmg': 'Урон по героям',
  'res.col.taken': 'Получено',
  'res.col.heal': 'Лечение',
  'res.col.monsters': 'Урон по чудищам',
  'res.col.captures': 'Захваты',
  'res.col.onPoints': 'На точках',
  'res.col.inkTitle': 'Чернила из общего запаса команды: покупки минус возврат за продажу',
  'res.col.ink': 'Потрачено чернил',
  'res.total': 'Всего',
  'res.victory': 'Победа',
  'res.defeat': 'Поражение',
  'res.duration': 'Матч длился {time}',

  /* ---------------- casting toasts, radar, countdown, match, map picker ---------------- */
  'cast.pickFoe': 'выберите врага',
  'cast.monsterReturning': 'монстр неуязвим, пока возвращается',
  'cast.tooFar': 'цель дальше {range} м',
  'toast.named': '{name}: {text}',
  'toast.noRelic': 'T: у команды нет реликвии — она покупается в лавке на базе',
  'toast.relicPassive': '{name}: работает сама, нажимать не нужно',
  'toast.artifactPassive': '{name}: работает сама, нажимать не нужно',
  'toast.cooling': '{name}: перезарядка {s} с',
  'toast.emptyArtifactSlot': '{key}: слот пуст — артефакт покупается в лавке на базе',
  'toast.emptySkillSlot': '{key}: слот пуст — навык покупается в лавке на базе',
  'toast.vialEmpty': '{name}: ещё пуста',
  'axis.dmg': 'Урон',
  'axis.hp': 'Прочность',
  'axis.mobility': 'Ход',
  'axis.range': 'Дальность',
  'axis.control': 'Контроль',
  'axis.support': 'Опора',
  'radar.empty': 'Состав ещё не набран.',
  'radar.summary': 'Сильны: {strong} · слабы: {weak}',
  'countdown.go': 'В бой!',
  'match.soundOff': 'Звук: выкл',
  'match.soundOn': 'Звук: вкл',
  'maps.baked': '{name} (основная)',
  'maps.builtin': 'Встроенные',
  'maps.mine': 'Мои карты',

  /* ---------------- server error codes (shared/protocol.ts ErrorCode) ---------------- */
  'error.BAD_MESSAGE': 'Сервер не понял запрос — попробуйте ещё раз.',
  'error.HELLO_REQUIRED': 'Соединение не готово — попробуйте ещё раз через секунду.',
  'error.PROTOCOL_MISMATCH': 'Версия клиента устарела — обновите страницу.',
  'error.MAP_MISMATCH': 'На сервере другая карта — обновите страницу.',
  'error.ROOM_NOT_FOUND': 'Комната не найдена или уже в игре.',
  'error.ROOM_FULL': 'В комнате уже нет мест.',
  'error.TOO_MANY_ROOMS': 'Сервер сейчас переполнен — попробуйте позже.',
  'error.NOT_IN_ROOM': 'Вы ещё не в комнате.',
  'error.ALREADY_IN_ROOM': 'Вы уже в комнате — сначала покиньте её.',
  'error.SEAT_INVALID': 'Такого места нет.',
  'error.SEAT_TAKEN': 'Это место уже занято.',
  'error.SEAT_NOT_YOURS': 'Это не ваше место.',
  'error.TEAM_FULL': 'В этой команде уже два игрока.',
  'error.HERO_INVALID': 'Такого героя нет.',
  'error.HERO_TAKEN': 'Этого героя уже взяли.',
  'error.HERO_REQUIRED': 'Сначала выберите героя.',
  'error.MATCH_ALREADY_STARTED': 'Матч уже начался.',
  'error.MATCH_NOT_ACTIVE': 'Матч ещё не начался.',
  'error.RATE_LIMITED': 'Слишком много запросов — подождите немного.',
  'error.SESSION_TAKEN_ELSEWHERE': 'Эта сессия открыта в другой вкладке или окне.',
  'error.unknown': 'Ошибка сервера: {code}',

  /* ---------------- online: lobby, connection ---------------- */
  'common.linkCopied': 'Ссылка скопирована',
  'lobby.closed': 'Комната закрыта.',
  'lobby.heroTaken': 'занят',
  'lobby.room': 'Комната {name}',
  'lobby.rooms': 'Комнаты',
  'lobby.create': 'Создать комнату',
  'lobby.seats': '{n} / 4 мест',
  'lobby.join': 'Войти',
  'lobby.emptyTitle': 'Пока никто не играет',
  'lobby.emptySub': 'Будьте первым — создайте комнату и позовите друзей.',
  'lobby.ready': 'Готов',
  'lobby.free': 'Свободно',
  'lobby.sit': 'Занять',
  'lobby.unbot': 'Убрать бота',
  'lobby.changeHero': 'Сменить героя',
  'lobby.pickHero': 'Выбрать героя',
  'lobby.disconnected': ' · отключён',
  'lobby.copyLink': 'Скопировать ссылку для друга',
  'lobby.linkAria': 'Ссылка на комнату',
  'lobby.leave': 'Покинуть комнату',
  'net.reload': 'Перезагрузить',
  'net.versionTitle': 'Доступна новая версия',
  'net.versionText': 'Ваша страница устарела и не может подключиться к серверу. Перезагрузите страницу.',
  'net.mapTitle': 'Карта обновилась',
  'net.mapText': 'На сервере другая карта, чем в вашей странице. Перезагрузите страницу, чтобы загрузить новую.',
  'net.sessionTitle': 'Сессия открыта в другой вкладке',
  'net.sessionText': 'Эта учётная запись сейчас используется в другой вкладке или окне. Перезагрузите страницу, чтобы начать здесь заново.',
  'net.toLobby': 'В лобби',
  'net.watchReplay': 'Смотреть повтор',

  /* ---------------- replays ---------------- */
  'replay.aborted': 'Матч прерван',
  'replay.teamWon': 'Победили {team}',
  'replay.bot': 'бот',
  'replay.empty': 'Повторов пока нет. Сыграйте матч онлайн — запись появится здесь и хранится 7 дней.',
  'replay.visionAll': 'Всё',
  'replay.follow': 'Следить за героем',
  'replay.again': 'Смотреть снова',
  'replay.exit': 'Выход',
  'replay.controls': 'Управление повтором',
  'replay.time': 'Время повтора',
  'replay.playTitle': 'Пауза / воспроизведение (Пробел)',
  'replay.pause': 'Пауза',
  'replay.play': 'Смотреть',
  'replay.speed': 'Скорость',
  'replay.vision': 'Обзор',
  'replay.copyLink': 'Копировать ссылку',
  'replay.respawn': 'возрождение {s} с',
  'replay.end': 'Конец записи',
  'replay.endWinner': '{score} · победили {team}',

  /* ---------------- map editor ---------------- */
  'editor.prop.haystack': 'Стог сена',
  'editor.prop.cart': 'Телега',
  'editor.prop.cross': 'Крест',
  'editor.prop.well': 'Колодец',
  'editor.wall.stone': 'Каменная',
  'editor.wall.palisade': 'Частокол',
  'editor.wall.hedge': 'Живая изгородь',
  'editor.building.house': 'Дом',
  'editor.building.tower': 'Башня',
  'editor.building.chapel': 'Часовня',
  'editor.building.mill': 'Мельница',
  'editor.decor.bush': 'Куст',
  'editor.decor.grave': 'Могила',
  'editor.decor.post': 'Столб',
  'editor.decor.barrel': 'Бочка',
  'editor.road.tract': 'Тракт',
  'editor.road.dirt': 'Грунтовка',
  'editor.road.trail': 'Лесная тропа',
  'editor.group.edit': 'Правка',
  'editor.group.required': 'Обязательные',
  'editor.group.points': 'Точки',
  'editor.group.shapes': 'Фигуры',
  'editor.group.props': 'Препятствия',
  'editor.group.lines': 'Линии',
  'editor.tool.select': 'Выбор / перемещение',
  'editor.tool.base': 'База',
  'editor.tool.side': 'Боковая точка A',
  'editor.tool.den': 'Логово',
  'editor.tool.trees': 'Дерево',
  'editor.tool.rocks': 'Камень',
  'editor.tool.pillars': 'Колонна',
  'editor.tool.camps': 'Лагерь',
  'editor.tool.bridges': 'Мост',
  'editor.tool.buildings': 'Здание',
  'editor.tool.brush': 'Трава',
  'editor.tool.decor': 'Декор',
  'editor.tool.fields': 'Поле',
  'editor.tool.fords': 'Брод',
  'editor.tool.walls': 'Стена / забор',
  'editor.tool.streams': 'Ручей',
  'editor.tool.roads': 'Дорога',
  'editor.tool.cliffs': 'Уступ',
  'editor.tool.ponds': 'Пруд',
  'editor.label.side': 'Точка A',
  'editor.label.walls': 'Стена',
  'editor.label.props': 'Препятствие',
  'editor.untitled': 'Без названия',
  'editor.toolSettings': 'Настройки инструмента',
  'editor.style': 'Стиль',
  'editor.type': 'Тип',
  'editor.width': 'Ширина',
  'editor.closed': 'Замкнутая область',
  'editor.hint.select': 'Клик — выбрать, перетаскивание — переместить. Пустая земля — панорама. ? — справка.',
  'editor.hint.base': 'Клик — поставить базу команды A (её отражение — база команды B). Диагональ следует за ней.',
  'editor.hint.side': 'Клик — поставить точку A (отражается в точку C).',
  'editor.hint.den': 'Клик — поставить логово; его отражение — логово другого монстра.',
  'editor.hint.bridges': 'Клик по ручью (в пределах 1 м от него).',
  'editor.hint.fords': 'Брод: клик по ручью — ляжет поперёк ближайшего ручья. Внутри брода ручей проходим, но бег на 20% медленнее.',
  'editor.hint.props': '{name}: клик — разместить, R — повернуть. Esc — вернуться к выбору.',
  'editor.hint.shape': '{name}: клик — добавить точку. Enter или двойной клик — закончить, Backspace — убрать последнюю, Esc — отменить.',
  'editor.hint.place': '{name}: клик — разместить. Esc — вернуться к выбору.',
  'editor.notSaved': 'Не сохранена',
  'editor.outOfRange': '{field} должен быть в пределах {min}..{max}',
  'editor.nothingSelected': 'Ничего не выбрано.',
  'editor.setsDiagonal': 'задаёт диагональ',
  'editor.mirrored': 'отражается',
  'editor.partCenter': 'центр (не отражается)',
  'editor.partHalf': 'половина',
  'editor.w': 'Ширина (w)',
  'editor.d': 'Глубина (d)',
  'editor.rx': 'Радиус x',
  'editor.rz': 'Радиус z',
  'editor.scale': 'Масштаб',
  'editor.rotation': 'Поворот °',
  'editor.vertices': '{n} {n|точка|точки|точек}{selected}. Перетащите квадрат, чтобы переместить точку; Alt+клик по ребру — добавить точку, Alt+клик по точке — удалить.',
  'editor.vertexSelected': ', точка {i} выбрана',
  'editor.vertex': 'Точка {i}',
  'editor.duplicate': 'Дублировать',
  'editor.delete': 'Удалить',
  'editor.toHalf': 'Вернуть в половину',
  'editor.toCenter': 'Сделать центральным объектом',
  'editor.centerTitle': 'Центральные объекты хранятся один раз, без отражения, и должны быть симметричны как набор: центральный объект вне начала координат держит рядом своего зеркального близнеца.',
  'editor.noProblems': 'Проблем нет: карту можно сохранить и играть на ней.',
  'editor.issueRoot': '(карта)',
  'editor.more': '… ещё {n}',
  'editor.renderError': 'ошибка рендера: {error}',
  'editor.rebuilt': 'пересобрано за {ms} мс',
  'editor.unsavedParen': '(не сохранена)',
  'editor.changed': ' — изменено',
  'editor.sizeStatus': '{w} × {h} м',
  'editor.snapOn': 'привязка {step} м',
  'editor.snapOff': 'привязка выкл.',
  'editor.noErrors': 'нет ошибок',
  'editor.problemsCount': '{n} {n|проблема|проблемы|проблем}',
  'editor.docTitle': '{mark}{name} — Редактор карт',
  'editor.newMap': 'новая карта',
  'editor.requiredNoDelete': 'База, точка A и логово обязательны: их нужно перемещать, а не удалять.',
  'editor.minVertices': 'Уже минимальное количество точек.',
  'editor.needPoints': 'Нужно хотя бы {n} {n|точка|точки|точек}.',
  'editor.fordNeedsStream': 'Брод кладётся через ручей: на карте нет ни одного ручья.',
  'editor.nothingToUndo': 'Отменять нечего.',
  'editor.nothingToRedo': 'Повторять нечего.',
  'editor.noneYet': '— пока нет —',
  'editor.activeMap': '{name} (активная)',
  'editor.confirmDiscard': 'Отменить несохранённые изменения?',
  'editor.seeProblems': '{problems} (см. «Проблемы»)',
  'editor.openFailed': 'Не удалось открыть {name}: {reason}',
  'editor.opened': 'Открыто: {name}',
  'editor.notSavedReason': 'Не сохранено: {reason}.',
  'editor.confirmOverwrite': '{name} уже есть. Перезаписать этой картой?',
  'editor.saved': 'Сохранено: {name}',
  'editor.promptFile': 'Имя файла в maps/ (строчные латинские буквы, цифры, дефисы):',
  'editor.promptName': 'Сохранить карту под названием:',
  'editor.confirmLeave': 'На карте есть несохранённые изменения: они пропадут при перезагрузке страницы (например, после матча). Всё равно выйти в меню?',
  'editor.cannotPlay': 'На этой карте играть нельзя: {problems} (см. «Проблемы»).',
  'editor.confirmExport': 'В карте {problems}: такой файл не откроется в игре, пока их не исправить. Всё равно экспортировать?',
  'editor.importFailedHead': 'Файл {file} не импортирован:',
  'editor.importFailed': 'Не импортировано: {reason}.',
  'editor.imported': 'Импортировано из {file}: сохраните карту («Сохранить как…»).',
  'editor.promptRename': 'Новое название для {name}:',
  'editor.renameFailed': 'Не переименовано: {reason}.',
  'editor.renamed': 'Переименовано: {name}',
  'editor.confirmRemove': 'Удалить карту {name}? Это нельзя отменить.',
  'editor.removeFailed': 'Не удалено: {reason}.',
  'editor.removed': 'Удалено: {name}',
  'editor.templateFailed': 'Не удалось открыть: {reason}',
  'editor.templateOpened': 'Встроенная карта открыта как образец: «Сохранить как…» сохранит копию.',
  'editor.confirmNew': 'Создать новую пустую карту {w} × {h} м?{lost}',
  'editor.changesLost': ' Несохранённые изменения будут потеряны.',
  'editor.activeFailed': 'Не удалось сделать активной: {reason}',
  'editor.nowActive': '{name} теперь активная карта: dev-сервер пересобирает игру, перезагрузите страницу.',
  'editor.devMaps': 'Карты в maps/',
  'editor.quoted': '«{name}»',
  'editor.draftBar': 'Enter или двойной клик — закончить · Backspace — убрать точку · Esc — отменить',
  'editor.done': 'Готово',
  'editor.cancel': 'Отмена',
  'editor.back': '← В меню',
  'editor.helpBtn': 'Справка (?)',
  'editor.map': 'Карта',
  'editor.name': 'Название',
  'editor.size': 'Размер (м)',
  'editor.pointRadius': 'Радиус точки',
  'editor.save': 'Сохранить',
  'editor.saveAs': 'Сохранить как…',
  'editor.play': 'Играть на этой карте',
  'editor.makeActive': 'Сделать активной',
  'editor.newBlank': 'Новая пустая карта…',
  'editor.export': 'Экспорт в файл',
  'editor.import': 'Импорт из файла',
  'editor.mapLabel': 'Карта',
  'editor.open': 'Открыть',
  'editor.rename': 'Переименовать…',
  'editor.remove': 'Удалить…',
  'editor.builtin': 'Встроенные карты',
  'editor.builtinNote': 'Только для чтения: откройте как образец и сохраните копию через «Сохранить как…».',
  'editor.selection': 'Выделение',
  'editor.viewTitle': 'Вид',
  'editor.snap': 'Привязка к сетке',
  'editor.metres': 'м',
  'editor.ovIssues': 'Проблемы карты',
  'editor.ovNav': 'Проходимость',
  'editor.ovSight': 'Закрывают обзор',
  'editor.problems': 'Проблемы',
  'editor.help': '<h2>Редактор карт</h2><p style="margin:0 0 8px;color:var(--muted)">Редактируется красная половина; синяя — её живое отражение на 180°. Размещение объекта на синей половине ставит его в зеркальную точку.</p><table><tr><td>Левая кнопка + перетаскивание</td><td>переместить объект под курсором (по пустой земле — панорама)</td></tr><tr><td>Правая / средняя кнопка + перетаскивание</td><td>панорама</td></tr><tr><td>Колесо</td><td>масштаб от курсора</td></tr><tr><td>Alt + колесо, R / Shift+R</td><td>поворот выделения (5° / 15°)</td></tr><tr><td>[ ]</td><td>уменьшить / увеличить выделение (размер, ширина, масштаб)</td></tr><tr><td>Синие квадраты</td><td>перетащите, чтобы изменить размер здания (w/d) или травы (rx/rz)</td></tr><tr><td>Перетащить вершину</td><td>изменить форму линии или полигона</td></tr><tr><td>Alt + клик по ребру / двойной клик по ребру</td><td>добавить вершину</td></tr><tr><td>Alt + клик по вершине</td><td>удалить эту вершину</td></tr><tr><td>Del / Backspace</td><td>удалить выбранную вершину или объект</td></tr><tr><td>Ctrl+D</td><td>дублировать</td></tr><tr><td>Ctrl+Z / Ctrl+Shift+Z</td><td>отменить / повторить</td></tr><tr><td>Ctrl+S</td><td>сохранить</td></tr><tr><td>Клик (инструменты линий)</td><td>добавить точку; Enter или двойной клик завершает, Backspace убирает последнюю, Esc отменяет</td></tr><tr><td>V / Esc</td><td>инструмент выбора / отмена; Esc без выделения — в меню</td></tr><tr><td>G</td><td>привязка к сетке вкл/выкл</td></tr><tr><td>F</td><td>показать всю карту</td></tr><tr><td>?</td><td>эта справка</td></tr></table>',
} as const satisfies Record<string, string>;
